export default "__VITE_ASSET__1a0a8da9__"